// extracted by mini-css-extract-plugin
module.exports = {"label":"InputFields_label__12Zyh","floatingLabel":"InputFields_floatingLabel__rMqwB","labelText":"InputFields_labelText__3_MXk"};